var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { style: _vm.s.container }, [
    _c("div", { style: _vm.s.wrapper }, [
      _c("div", { style: _vm.s.title }, [
        _vm._v(_vm._s(_vm.Title)),
        _c("span", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.ShowClose,
              expression: "ShowClose"
            }
          ],
          style: _vm.s.close,
          on: { click: _vm.close }
        })
      ]),
      _c("div", { staticClass: "head" }, [
        _c("span", { staticClass: "block-ctx" }, [
          _c("span", { staticClass: "first" }, [
            _vm._v(_vm._s(_vm.activeAddr.substr(0, 10)))
          ]),
          _c("span", { staticClass: "mid" }, [
            _vm._v(
              _vm._s(_vm.activeAddr.substring(10, _vm.activeAddr.length - 5))
            )
          ]),
          _c("span", { staticClass: "last" }, [
            _vm._v(_vm._s(_vm.activeAddr.substring(_vm.activeAddr.length - 5)))
          ])
        ])
      ]),
      _c(
        "div",
        { style: _vm.s.body },
        [
          _c("div", { staticClass: "verify__tips" }, [
            _vm._v(_vm._s(_vm.$t("assets.ledger.confirm.verifyAddress")))
          ]),
          _c("lottie", {
            staticClass: "ledger_lottie",
            attrs: { type: "validate" }
          })
        ],
        1
      ),
      _vm.ShowBottom
        ? _c("div", { style: _vm.s.btnGroup }, [
            !!_vm.STxt
              ? _c(
                  "div",
                  {
                    style: [
                      _vm.s.btn,
                      _vm.BtnUnuse || _vm.btnUnuse ? _vm.s.unUse : undefined
                    ],
                    on: { click: _vm.rClick }
                  },
                  [_vm._v(_vm._s(_vm.STxt))]
                )
              : _vm._e(),
            !_vm.STxt
              ? _c(
                  "div",
                  { style: [_vm.s.lBtn, _vm.s.btn], on: { click: _vm.lClick } },
                  [_vm._v(_vm._s(_vm.LTxt))]
                )
              : _vm._e(),
            !_vm.STxt
              ? _c(
                  "div",
                  {
                    style: [
                      _vm.s.btn,
                      _vm.BtnUnuse || _vm.btnUnuse ? _vm.s.unUse : undefined
                    ],
                    on: { click: _vm.rClick }
                  },
                  [_vm._v(_vm._s(_vm.RTxt))]
                )
              : _vm._e()
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }